import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-white mt-20 md:mt-28 mx-4 md:mx-6 rounded-2xl mb-4 md:mb-6" role="contentinfo">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <h3 className="font-heading text-2xl md:text-3xl font-light text-white mb-4">
              订阅每日热瓜
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6 font-label">
              第一时间获取最新爆料和吃瓜资讯，不错过任何精彩内容。
            </p>
            <form className="flex flex-col sm:flex-row gap-3" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                name="email"
                placeholder="输入邮箱地址"
                className="flex-1 bg-transparent border-b border-foreground-600 px-2 py-3 text-sm text-white placeholder:text-foreground-500 outline-none focus:border-primary-400 transition-colors font-label"
              />
              <button type="submit" className="btn-primary text-sm whitespace-nowrap">
                立即订阅
              </button>
            </form>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-4">
              快速导航
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/" className="text-sm text-white/80 hover:text-primary-400 transition-colors link-underline font-label">
                  首页
                </Link>
              </li>
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-white/80 hover:text-primary-400 transition-colors link-underline font-label"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-sm text-white/80 hover:text-primary-400 transition-colors link-underline font-label">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3 md:col-start-10">
            <h4 className="font-label text-xs uppercase tracking-wider text-foreground-400 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-3 text-sm text-white/80 font-label">
              <p>
                <i className="ri-mail-line mr-2"></i>
                contact@51chigua.com
              </p>
              <p>
                <i className="ri-phone-line mr-2"></i>
                400-888-5151
              </p>
            </div>
            <h4 className="font-label text-xs uppercase tracking-wider text-foreground-400 mt-6 mb-4">
              商务合作
            </h4>
            <p className="text-sm text-white/80 leading-relaxed font-label">
              北京市朝阳区望京SOHO T1-1208
            </p>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-white/70 hover:text-primary-400 transition-colors link-underline font-label" rel="nofollow">
              微博
            </a>
            <a href="#" className="text-sm text-white/70 hover:text-primary-400 transition-colors link-underline font-label" rel="nofollow">
              抖音
            </a>
            <a href="#" className="text-sm text-white/70 hover:text-primary-400 transition-colors link-underline font-label" rel="nofollow">
              公众号
            </a>
          </div>
          <p className="text-sm text-foreground-500 font-label">
            &copy; {currentYear} 51在线吃瓜网 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-white/70 hover:text-primary-400 transition-colors link-underline font-label" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-sm text-white/70 hover:text-primary-400 transition-colors link-underline font-label" rel="nofollow">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}